import { graphql } from "react-relay";
import { EventSummary } from "@components/event-summary";

export const eventSmartHoldInfoFragments = {
  user: graphql`
    fragment EventSmartHoldInfo_user on User {
      ...EventSummary_user
    }
  `,
  org: graphql`
    fragment EventSmartHoldInfo_org on Org {
      ...EventSummary_org
      id
      primaryOrgCalendar
      primaryOrgEmail
      shadowCalendarSettingsErrorable {
        __typename
        ... on ShadowCalendarSettings {
          shadowCalendarId
        }
      }
    }
  `,
  event: graphql`
    fragment EventSmartHoldInfo_event on Event
    @argumentDefinitions(calendarId: { type: "String!" }) {
      ...EventSummary_event @arguments(calendarId: $calendarId)
      title
      isClockwiseEvent
      organizer {
        urnValue
      }
      eventKey {
        externalEventId
      }
      annotatedEvent {
        orgTags {
          tag
          state {
            subjectType
            subjectValue
            value
            active
          }
        }
      }
      startTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
      endTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  `,
  smartHoldEventInfo: graphql`
    fragment EventSmartHoldInfo_smartHoldEventInfo on SmartHoldEventInfo {
      isPreTravelTime
      isPostTravelTime
      isMeetingPrep
      originEvent {
        title
        eventKey {
          externalEventId
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
        }
      }
    }
  `,
};
